/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { ClosedEnum } from "../../types/enums.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type ListExternalUserBudgetEventsRequest = {
  id: string;
  orgId?: string | undefined;
};

export const ListExternalUserBudgetEventsType = {
  ThresholdAlert: "threshold_alert",
  Blocked: "blocked",
} as const;
export type ListExternalUserBudgetEventsType = ClosedEnum<
  typeof ListExternalUserBudgetEventsType
>;

export type ListExternalUserBudgetEventsData = {
  id: string;
  budgetId: string;
  type: ListExternalUserBudgetEventsType;
  pct: number | null;
  periodKey: string;
  targetId: string;
  spendSnapshot: number;
  limitSnapshot: number;
  createdAt: string;
};

/**
 * OK
 */
export type ListExternalUserBudgetEventsResponseBody = {
  object: "list";
  data: Array<ListExternalUserBudgetEventsData>;
};

/** @internal */
export const ListExternalUserBudgetEventsRequest$inboundSchema: z.ZodType<
  ListExternalUserBudgetEventsRequest,
  z.ZodTypeDef,
  unknown
> = z.object({
  id: z.string(),
  org_id: z.string().optional(),
}).transform((v) => {
  return remap$(v, {
    "org_id": "orgId",
  });
});
/** @internal */
export type ListExternalUserBudgetEventsRequest$Outbound = {
  id: string;
  org_id?: string | undefined;
};

/** @internal */
export const ListExternalUserBudgetEventsRequest$outboundSchema: z.ZodType<
  ListExternalUserBudgetEventsRequest$Outbound,
  z.ZodTypeDef,
  ListExternalUserBudgetEventsRequest
> = z.object({
  id: z.string(),
  orgId: z.string().optional(),
}).transform((v) => {
  return remap$(v, {
    orgId: "org_id",
  });
});

export function listExternalUserBudgetEventsRequestToJSON(
  listExternalUserBudgetEventsRequest: ListExternalUserBudgetEventsRequest,
): string {
  return JSON.stringify(
    ListExternalUserBudgetEventsRequest$outboundSchema.parse(
      listExternalUserBudgetEventsRequest,
    ),
  );
}
export function listExternalUserBudgetEventsRequestFromJSON(
  jsonString: string,
): SafeParseResult<ListExternalUserBudgetEventsRequest, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) =>
      ListExternalUserBudgetEventsRequest$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'ListExternalUserBudgetEventsRequest' from JSON`,
  );
}

/** @internal */
export const ListExternalUserBudgetEventsType$inboundSchema: z.ZodNativeEnum<
  typeof ListExternalUserBudgetEventsType
> = z.nativeEnum(ListExternalUserBudgetEventsType);
/** @internal */
export const ListExternalUserBudgetEventsType$outboundSchema: z.ZodNativeEnum<
  typeof ListExternalUserBudgetEventsType
> = ListExternalUserBudgetEventsType$inboundSchema;

/** @internal */
export const ListExternalUserBudgetEventsData$inboundSchema: z.ZodType<
  ListExternalUserBudgetEventsData,
  z.ZodTypeDef,
  unknown
> = z.object({
  id: z.string(),
  budget_id: z.string(),
  type: ListExternalUserBudgetEventsType$inboundSchema,
  pct: z.nullable(z.number()),
  period_key: z.string(),
  target_id: z.string(),
  spend_snapshot: z.number(),
  limit_snapshot: z.number(),
  created_at: z.string(),
}).transform((v) => {
  return remap$(v, {
    "budget_id": "budgetId",
    "period_key": "periodKey",
    "target_id": "targetId",
    "spend_snapshot": "spendSnapshot",
    "limit_snapshot": "limitSnapshot",
    "created_at": "createdAt",
  });
});
/** @internal */
export type ListExternalUserBudgetEventsData$Outbound = {
  id: string;
  budget_id: string;
  type: string;
  pct: number | null;
  period_key: string;
  target_id: string;
  spend_snapshot: number;
  limit_snapshot: number;
  created_at: string;
};

/** @internal */
export const ListExternalUserBudgetEventsData$outboundSchema: z.ZodType<
  ListExternalUserBudgetEventsData$Outbound,
  z.ZodTypeDef,
  ListExternalUserBudgetEventsData
> = z.object({
  id: z.string(),
  budgetId: z.string(),
  type: ListExternalUserBudgetEventsType$outboundSchema,
  pct: z.nullable(z.number()),
  periodKey: z.string(),
  targetId: z.string(),
  spendSnapshot: z.number(),
  limitSnapshot: z.number(),
  createdAt: z.string(),
}).transform((v) => {
  return remap$(v, {
    budgetId: "budget_id",
    periodKey: "period_key",
    targetId: "target_id",
    spendSnapshot: "spend_snapshot",
    limitSnapshot: "limit_snapshot",
    createdAt: "created_at",
  });
});

export function listExternalUserBudgetEventsDataToJSON(
  listExternalUserBudgetEventsData: ListExternalUserBudgetEventsData,
): string {
  return JSON.stringify(
    ListExternalUserBudgetEventsData$outboundSchema.parse(
      listExternalUserBudgetEventsData,
    ),
  );
}
export function listExternalUserBudgetEventsDataFromJSON(
  jsonString: string,
): SafeParseResult<ListExternalUserBudgetEventsData, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => ListExternalUserBudgetEventsData$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'ListExternalUserBudgetEventsData' from JSON`,
  );
}

/** @internal */
export const ListExternalUserBudgetEventsResponseBody$inboundSchema: z.ZodType<
  ListExternalUserBudgetEventsResponseBody,
  z.ZodTypeDef,
  unknown
> = z.object({
  object: z.literal("list"),
  data: z.array(z.lazy(() => ListExternalUserBudgetEventsData$inboundSchema)),
});
/** @internal */
export type ListExternalUserBudgetEventsResponseBody$Outbound = {
  object: "list";
  data: Array<ListExternalUserBudgetEventsData$Outbound>;
};

/** @internal */
export const ListExternalUserBudgetEventsResponseBody$outboundSchema: z.ZodType<
  ListExternalUserBudgetEventsResponseBody$Outbound,
  z.ZodTypeDef,
  ListExternalUserBudgetEventsResponseBody
> = z.object({
  object: z.literal("list"),
  data: z.array(z.lazy(() => ListExternalUserBudgetEventsData$outboundSchema)),
});

export function listExternalUserBudgetEventsResponseBodyToJSON(
  listExternalUserBudgetEventsResponseBody:
    ListExternalUserBudgetEventsResponseBody,
): string {
  return JSON.stringify(
    ListExternalUserBudgetEventsResponseBody$outboundSchema.parse(
      listExternalUserBudgetEventsResponseBody,
    ),
  );
}
export function listExternalUserBudgetEventsResponseBodyFromJSON(
  jsonString: string,
): SafeParseResult<
  ListExternalUserBudgetEventsResponseBody,
  SDKValidationError
> {
  return safeParse(
    jsonString,
    (x) =>
      ListExternalUserBudgetEventsResponseBody$inboundSchema.parse(
        JSON.parse(x),
      ),
    `Failed to parse 'ListExternalUserBudgetEventsResponseBody' from JSON`,
  );
}
